export default "__VITE_ASSET__DvVhhrWb__"